// home.js
import React from 'react';
import config from '../../../../config/config';
import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import { loadData } from '../Util/List/CustomList/loadData';
import Units from './Units';
import { useSelector } from 'react-redux';

import { TabContent, TabPane, Nav, NavItem, NavLink, Col } from 'reactstrap';
import classnames from 'classnames';

import '../home/Home.css';

function Contractualization({ activeTab, setActiveTab, showNav }) {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });
    const friendly_url = sessionSelector.pdc_project_friendly_url;

    const paths = {
        endpoint: config.endpoints.backend + 'portal/getallcontractualizations',
        endpointGetAllAdjustTypes:
            config.endpoints.backend + 'portal/getalladjusttypes'
    };

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_adjust_type_id',
                type: 'select',
                label: 'Tipo',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllAdjustTypes,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            }
        ]
    };

    const list = {
        labelTitle: 'Contratualizações',
        icon: 'fa-file-contract',
        filter: {
            friendly_url
        },
        canDownload: true,
        fieldToDownload: 'file',
        formFilters: filters,
        columns: [
            {
                name: 'number',
                label: 'Número',
                width: '10%'
            },
            {
                name: 'adjust_type',
                label: 'Tipo de Ajuste',
                width: '10%'
            },
            {
                name: 'object',
                label: 'Objeto',
                width: '75%'
            },
            {
                name: 'publish_date',
                label: 'Data de Publicação',
                width: '10%'
            }
        ]
    };

    return (
        <div
            className="mt-3 mr-3"
            style={{
                marginLeft: '30px'
            }}
        >
            {showNav && (
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'contractualizations'
                            })}
                            onClick={() => {
                                setActiveTab('contractualizations');
                            }}
                        >
                            Contatualizações
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'units'
                            })}
                            onClick={() => {
                                setActiveTab('units');
                            }}
                        >
                            Unidades
                        </NavLink>
                    </NavItem>
                </Nav>
            )}
            <TabContent activeTab={activeTab} className="bg-white">
                <TabPane tabId="contractualizations">
                    <Col sm="12">
                        <CustomListContainer
                            canAdd={false}
                            labelTitle={list.labelTitle}
                            icon={list.icon}
                            content={
                                <CustomList list={{ ...list, ...paths }} />
                            }
                        />
                    </Col>
                </TabPane>
                <TabPane tabId="units">
                    <Col className="d-flex align-center justify-center" sm="12">
                        <Units />
                    </Col>
                </TabPane>
            </TabContent>
        </div>
    );
}

export default Contractualization;
